import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { SearchRequestFormatter } from "../SearchRequestFormatter";
export function createSearchConnection() {
    return createRESTConn({
        name: ConnectionNames.search,
        handlers: {
            requestFormatter: SearchRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateSearchConnection.js.map